import { Component } from '@angular/core';

@Component({
  selector: 'app-tmc-auth-frame',
  templateUrl: './tmc-auth-frame.component.html',
  styleUrls: ['./tmc-auth-frame.component.scss']
})
export class TmcAuthFrameComponent {

}
